<main>
  <h1>Profile Page</h1>

  <form (ngSubmit)="updateUser()">
    <h2>Name</h2>
    <mat-form-field style="width: 100%" appearance="fill">
      <mat-label>Display Name</mat-label>
      <input matInput #message maxlength="75" placeholder="Anonymous One"
             [(ngModel)]="userDisplayName" name="name" [disabled]="!editing" />
      <mat-hint align="start">
        <strong>Your name appears on your Profile page, as the author in stories, and in your comments. It is a required field.</strong>
      </mat-hint>
      <mat-hint align="end">{{message.value.length}} / 75</mat-hint>
    </mat-form-field>
    <div><br /></div>
    <button mat-raised-button type="button" color="primary" (click)="edit()" *ngIf="!editing" [disabled]="nameLoading">Edit</button>
    <button mat-button type="button" color="warn" (click)="cancelEdit()" *ngIf="editing" [disabled]="nameLoading">Cancel</button>
    <button mat-raised-button type="submit" color="accent" *ngIf="editing"
            [disabled]="userDisplayName===user?.displayName || nameLoading">{{nameLoading ? 'Saving' : 'Save'}}</button>
  </form>

  <mat-divider></mat-divider>

  <section class="profile-picture-container">
    <h2>Photo</h2>
    <p>Your photo appears with your stories and comments across {{companyInformation.name}}.</p>
    <anon-photo-upload [user]="this.auth.user!"></anon-photo-upload>
  </section>

  <mat-divider></mat-divider>

  <form>
    <h2>Email</h2>
    <p>Your email address is used to login to Anonymous Systems and cannot be changed.</p>
    <mat-form-field style="width: 100%" appearance="fill">
      <mat-label>Account Email</mat-label>
      <input matInput placeholder="email@anonsys.tech" [value]="user?.email"
             name="email" [disabled]="true" />
    </mat-form-field>
    <div><br /></div>
    <button mat-raised-button type="button" color="primary" [disabled]="true">Edit</button>
  </form>

  <mat-divider></mat-divider>

  <section class="delete-account-container">
    <h2>Delete Account</h2>
    <p>Permanently delete your account and all of your content.</p>
    <button mat-button type="button" color="primary" *ngIf="!deleteButtonPushed" (click)="deleteButtonPushed = true">Delete account</button>
    <ng-template [ngIf]="deleteButtonPushed">
      <h3>Are you sure, delete account?</h3>
      <button mat-button type="button" color="warn" (click)="deleteButtonPushed = false">No, cancel</button>
      <button mat-raised-button type="button" color="primary" (click)="delete()">Yes, delete it</button>
    </ng-template>
  </section>

</main>
